import { Plus } from "lucide-react";
import { ProfileActionsDropdown, type InsitiProfile } from "@agentic_conversation/pages/chat/components/custom/insiti-link";

interface ProfileCardActionsProps {
  profile: InsitiProfile;
}

export function ProfileCardActions({ profile }: ProfileCardActionsProps) {
  return (
    <div className="absolute top-3 right-3">
      <ProfileActionsDropdown
        profile={profile}
        trigger={
          <button
            type="button"
            className="w-6 h-6 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors"
          >
            <Plus className="w-4 h-4" />
          </button>
        }
        placement="bottom-end"
      />
    </div>
  );
}
